module.exports = __webpack_public_path__ + "static/002.thumb-f5f8b100b9979c4b6b78cda317f4ccd9.jpg";